import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-forecast",
  "use": "app-icon-forecast-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-forecast\"><path d=\"M12.8 17v2.4H19a.8.8 0 110 1.6H4.6a.8.8 0 110-1.6h6.6V17H3a1 1 0 01-1-1V4a1 1 0 011-1h18a1 1 0 011 1v12a1 1 0 01-1 1h-8.2zM3.5 5v10a.5.5 0 00.5.5h16a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5H4a.5.5 0 00-.5.5zm12.57 2.387l-.792-.685 3.003-1-.632 3.057-.788-.686-4.109 4.686-3.317-2.686-3.951 3.897-.737-.737 4.58-4.529 3.265 2.58 3.477-3.897z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol